import React, { useContext, useEffect } from "react";
import { Upload, message } from "antd";
import ImgCrop from "antd-img-crop";
import { context } from "./../../context/context";
import config from "../../services/config.json";

const EventUploadMedia = () => {
    // context
    const {
        eventMedia,
        setEventMedia,
        eventCover,
        setEventCover,
        setEventCoverId,
        eventMediaId,
        setEventMediaId,
        eventCoverId,
    } = useContext(context);

    // useEffect
    useEffect(() => {
        setEventCoverId(eventCover[0] ? eventCover[0]?._id : null);
        const ids = [];
        const files = [];
        eventMedia.map((file) => {
            ids.push(file._id);
            files.push({
                uid: file._id,
                name: `${file.type}/${file._id}`,
                status: "done",
                url: file.address,
            });
        });
        setEventMediaId(ids);
        setEventMedia(files);
        setEventCover([
            {
                uid: eventCoverId,
                name: "image.png",
                status: "done",
                url: eventCover[0]?.address,
            },
        ]);
    }, []);
    // upload
    const onChangeCover = (info) => {
        setEventCover(info.fileList);
        if (info.file.status === "done") {
            message.success(`${info.file.name} فایل با موفقیت آپلود شد`);
            setEventCoverId(info.file.response.files[0]._id);
        } else if (info.file.status === "error") {
            message.error(` در آپلود فایل خطایی رخ داد!`);
        }
    };
    const onChange = (info) => {
        setEventMedia(info.fileList);
        if (info.file.status === "done") {
            message.success(`${info.file.name} فایل با موفقیت آپلود شد`);
            info.file.response.files.map((file) => {
                setEventMediaId([...eventMediaId, file._id]);
            });
        } else if (info.file.status === "error") {
            message.error(` در آپلود فایل خطایی رخ داد!`);
        }
    };
    const onPreview = async (file) => {
        let src = file.url;
        if (!src) {
            src = await new Promise((resolve) => {
                const reader = new FileReader();
                reader.readAsDataURL(file.originFileObj);
                reader.onload = () => resolve(reader.result);
            });
        }
        const image = new Image();
        image.src = src;
        const imgWindow = window.open(src);
        imgWindow?.document.write(image.outerHTML);
    };
    const handleRemove = (info) => {
        const newFiles = eventMedia.filter((file) => file !== info);
        const newIds = eventMediaId.filter((id) => id !== info.uid);
        setEventMediaId(newIds);
        setEventMedia(newFiles);
    };

    return (
        <div
            style={{
                display: "flex",
                flexDirection: "column",
                padding: "2rem 0",
                gap: "2rem",
            }}
        >
            <ImgCrop modalTitle="ویرایش عکس" aspect={2} rotationSlider>
                <Upload
                    maxCount={1}
                    multiple={false}
                    name="objectKey"
                    action={`${config.parkopoloApi}/api/FileManager/uploadFile/?parentId=65b9e7ff3bdc08e33ab77df6`}
                    listType="picture-card"
                    fileList={eventCover}
                    onChange={onChangeCover}
                    onPreview={onPreview}
                >
                    {eventCover?.length < 5 && "+ آپلود عکس کاور"}
                </Upload>
            </ImgCrop>
            <ImgCrop modalTitle="ویرایش عکس" rotationSlider>
                <Upload
                    accept="image/*"
                    multiple={false}
                    name="objectKey"
                    action={`${config.parkopoloApi}/api/FileManager/uploadFile/?parentId=65b9e80a3bdc08e33ab77e03`}
                    listType="picture-card"
                    fileList={eventMedia}
                    onChange={onChange}
                    onPreview={onPreview}
                    onRemove={handleRemove}
                >
                    {eventCover?.length < 3 && "+ آپلود عکس"}
                </Upload>
            </ImgCrop>
            <Upload
                accept="video/*"
                multiple={false}
                name="objectKey"
                action={`${config.parkopoloApi}/api/FileManager/uploadFile/?parentId=65b9e80a3bdc08e33ab77e03`}
                listType="picture-card"
                fileList={eventMedia}
                onChange={onChange}
                onPreview={onPreview}
                onRemove={handleRemove}
            >
                {eventCover?.length < 3 && "+ آپلود ویدیو"}
            </Upload>
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "end",
                    flexWrap: "wrap",
                    gap: "2rem",
                }}
            >
                {eventMedia.map((media) => {
                    if (media.name && media.name.slice(0, 5) === "video") {
                        return (
                            <video
                                src={media.url}
                                controls
                                style={{ width: "20rem" }}
                            ></video>
                        );
                    } else if (
                        media.type &&
                        media.type.slice(0, 5) === "video"
                    ) {
                        return (
                            <video
                                src={media.response?.files[0].address}
                                controls
                                style={{ width: "20rem" }}
                            ></video>
                        );
                    }
                })}
            </div>
        </div>
    );
};

export default EventUploadMedia;
